<path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.9606"
    d="M21.8613 12.2281H1.89789m6.29818-6.99983-7 7.00003 7 7"
/>
